<template>

    <div>
        <div class="nav-tabs-custom">
            <ul class="nav nav-tabs nav-fixed-tabs">
                <li
                    v-for="child in getMenu"
                    :class="{'active':isActiveChildRoute(child)}"
                >
                    <router-link :to="{name:child.route}">
                        {{ child.name }}
                    </router-link>
                </li>
            </ul>
        </div>

        <router-view></router-view>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';
import Lang from '../../Lang';
import MenuItem from "../../Libraries/MenuItem";
import FixedTabs from "../../Libraries/FixedTabs";

export default {

    computed: {
        ...mapGetters([
            'can',
        ]),

        getMenu() {
            return [
                new MenuItem(Lang.get('projects.tabs.projects'), 'projects.index'),
                new MenuItem(Lang.get('projects.tabs.sort'), 'projects.sort.index'),
            ];
        },
    },

    destroyed(){
        FixedTabs.unset();
    },

    methods: {
        isActiveChildRoute(child) {
            return child.route === this.$route.name
                || (child.route === 'projects.index' && this.$route.name.split('.')[1] == 'details');
        },
    },

    mounted(){
        FixedTabs.set();

        if (document.getElementById('has-waiting-tickets')) {
            document.querySelector('.nav-tabs-custom .nav-fixed-tabs').style.setProperty('top', '105px', 'important');
        }
    },

    name:'ProjectsLayout',

}

</script>
